// src/components/gestionEvento/AddAthleteModal.js

import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import RegistroForm from '../../../../pages/EventPages/RegistroForm'; // Asegúrate de que la ruta sea correcta

const AddAthleteModal = ({ open, onClose, onAdd }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Registro de Atleta</DialogTitle>
      <DialogContent>
        {/* Se utiliza el componente RegistroForm actualizado para el registro completo */}
        <RegistroForm onAdd={onAdd} onClose={onClose} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};

AddAthleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default AddAthleteModal;
